/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import clientReducer, { clientAssociationReducer } from '../pages/duck/client/reducer';
import userReducer, { userPreferenceReducer, membersReducer } from '../pages/duck/user/reducer';
import permissionReducer from '../pages/duck/permission/reducer';
import documentReducer from '../pages/duck/document/reducer';
import folderReducer from '../pages/duck/folder/reducer';
import roleReducer from '../pages/duck/role/reducer';
import reviewReducer from '../pages/duck/review/reducer';
import settingReducer from '../pages/duck/setting/reducer';
import appointmentReducer from '../pages/duck/appointment/reducer';
import messageReducer, {
  messageTemplateReducer,
  draftMsgReducer,
} from '../pages/duck/message/reducer';
import invoiceReducer, { invoiceTemplateReducer } from '../pages/duck/invoice/reducer';
import taskReducer from '../pages/duck/task/reducer';
import taskTemplateReducer from '../pages/duck/task/task-template/reducer';
import paymentReducer from '../pages/duck/payment/reducer';
import companyReducer from '../pages/duck/company/reducer';
import dashboardReducer from '../pages/duck/dashboard/reducer';
import taxReturnReducer from '../pages/duck/tax-return/reducer';
import notificationReducer from '../pages/duck/notification/reducer';
import locationReducer from '../pages/duck/setting/appointment/location/reducer';
import serviceReducer from '../pages/duck/setting/appointment/services/reducer';
import workingHourReducer from '../pages/duck/setting/appointment/workingHour/reducer';
import statusReducer from '../pages/duck/status/reducer';
//import hierarchyReducer from '../pages/duck/hierarchy/reducer';
import teamReducer from '../pages/duck/team/reducer';
import historyReducer from '../pages/duck/history/reducer';
import couponsReducer from '../pages/duck/coupon/reducer';
import supportReducer, { conversationReducer } from '../pages/duck/support/reducer';
import chatReducer from '../pages/duck/chat/reducer';
import signatureReducer from '../pages/duck/document/signature/reducer';
import tagReducer from '../pages/duck/tag/reducer';

import history from '../utils/history';
import reportReducer from '../pages/duck/reports/reducer';
import legalDocumentsReducer from '../pages/duck/legalDocuments/reducer';
import supportV2Reducer from '../pages/duck/supportV2/reducer';
import keyReducer from '../pages/duck/key/reducer';
import noteReducer from '../pages/duck/note/reducer';
import accountingReducer from '../pages/duck/accounting/reducer';
import fieldTemplateReducer from '../pages/duck/client/client-template/reducer';

const appReducer = combineReducers({
  router: connectRouter(history),
  clients: clientReducer,
  users: userReducer,
  permission: permissionReducer,
  associations: clientAssociationReducer,
  roles: roleReducer,
  documents: documentReducer,
  reviews: reviewReducer,
  settings: settingReducer,
  appointments: appointmentReducer,
  messages: messageReducer,
  messageTemplates: messageTemplateReducer,
  invoices: invoiceReducer,
  tasks: taskReducer,
  taskTemplates: taskTemplateReducer,
  notifications: notificationReducer,
  payments: paymentReducer,
  companies: companyReducer,
  dashboards: dashboardReducer,
  invoiceTemplates: invoiceTemplateReducer,
  folders: folderReducer,
  taxReturns: taxReturnReducer,
  locations: locationReducer,
  services: serviceReducer,
  workingHours: workingHourReducer,
  status: statusReducer,
  userPreference: userPreferenceReducer,
  //hierarchy: hierarchyReducer,
  team: teamReducer,
  member: membersReducer,
  histories: historyReducer,
  coupons: couponsReducer,
  support: supportReducer,
  conversations: conversationReducer,
  chats: chatReducer,
  signatures: signatureReducer,
  tags: tagReducer,
  reports: reportReducer,
  legalDocuments: legalDocumentsReducer,
  draftMessages: draftMsgReducer,
  supportV2: supportV2Reducer,
  key: keyReducer,
  notes: noteReducer,
  accounting: accountingReducer,
  fieldTemplates: fieldTemplateReducer,
});

const rootReducer = (state, action) => {
  if (action && action.type === 'LOG_OUT_SUCCESS') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
